import { ComplianceRule } from 'dashboard/models/compliance-rule';
import Action from 'lib/interfaces/Action';

export type ComplianceRulesActions = Action<
  ComplianceRulesActionType.SetComplianceRules,
  SetComplianceRulesPayload
>;

export enum ComplianceRulesActionType {
  SetComplianceRules = 'SET_COMPLIANCE_RULES',
}

interface SetComplianceRulesPayload {
  complianceRules: ComplianceRule[];
}

export function setComplianceRules(
  complianceRules: ComplianceRule[],
): Action<ComplianceRulesActionType.SetComplianceRules, SetComplianceRulesPayload> {
  return {
    payload: {
      complianceRules,
    },
    type: ComplianceRulesActionType.SetComplianceRules,
  };
}
